import clsx from 'clsx';
import React from 'react';

import { useClientSmallScreen } from '@/lib/user-agent/client';

import Container from '@/components/@base/container';
import CommentCard from '@/components/app/product/components/@shared/comment-card';
import CommentsHeader from '@/components/app/product/components/@shared/comments-header';
import Section from '@/components/app/product/components/@shared/section';
import { AiComment } from '@/components/app/product/components/comments/ai-comment';
import Props from '@/components/app/product/components/content/comments-summary/type';

import { DATA_CY_COMMENTS_SUMMARY } from '@/constant/cypress';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function CommentsSummary({
  comments,
  rate,
  handleShowMoreComments,
  aiReviewSummary,
  ...props
}: Props) {
  const isSmallScreen = useClientSmallScreen();
  return (
    <Section
      data-cy={DATA_CY_COMMENTS_SUMMARY}
      id='commentsSection'
      expandable
      showMoreLabel={!isSmallScreen ? productLocalization.seeAllComments : undefined}
      onShowMoreClick={handleShowMoreComments}
      expandOnShowMoreClick={false}
      className={clsx('mx-0! px-0!', aiReviewSummary && 'max-h-[600px]! md:max-h-[700px]!')}
    >
      <CommentsHeader
        className='px-3.5 md:px-[30px]'
        rate={rate}
        onAddCommentClick={handleShowMoreComments}
        isCommentsSummary={true}
      />
      {aiReviewSummary && (
        <Container className='mx-3.5 md:mx-[30px]'>
          <AiComment aiReviewSummary={aiReviewSummary} />
        </Container>
      )}
      {comments.map((comment) => (
        <Container
          key={comment.id}
          className='mx-3.5 my-5 rounded-lg border-[1px] border-[#E9EBF1] pt-2.5! pb-6 md:mx-[30px] md:pt-0'
        >
          <CommentCard {...comment} className='px-6!' />
        </Container>
      ))}
    </Section>
  );
}
